<template>
    <b-row>
        <b-col cols="12" class="details-dam-name-wrapper">
            <b-link
                :to="profileLink"
                class="details-dam-name"
            >
                {{ $t('dashboard.dam') }} {{ currentDamSelectedName }}
            </b-link>
            <a class="closebtn" @click="closePanel">&times;</a>
        </b-col>
    </b-row>
</template>

<script>
    // utils, vuex
    import {CLEAR_CURRENT_DAM, SET_DAM_ERROR} from "../../store/actions/dashboard";
    import {mapActions, mapGetters} from "vuex";

    /**
     * Computes the correct station name.
     */

    export default {
        name: "RightPanelContainerName",
        methods: {
            ...mapActions([CLEAR_CURRENT_DAM, SET_DAM_ERROR]),
            async closePanel() {
                await this.CLEAR_CURRENT_DAM();
                await this.SET_DAM_ERROR(false);
            }
        },
        computed: {
            ...mapGetters(['currentDamSelectedName', 'currentDamSelectedId']),
            profileLink() {
                let linkConfig = {name: 'profile'};
                if (this.currentDamSelectedId || this.$route.params.id) {
                    linkConfig['params'] = {id: this.currentDamSelectedId || this.$route.params.id};
                }
                return linkConfig;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";

    .details-dam-name-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        border-bottom: 1px solid #6299EB;
    }

    .details-dam-name {
        text-align: left;
        font: 800 16px/22px Nunito, sans-serif;
        letter-spacing: 0;
        color: #6299EB;
        opacity: 1;
    }

    .closebtn {
        color: #435061;
        font-size: 22px;
        text-decoration: none;
        cursor: pointer;
    }
</style>